import type { TImage, TImageLoading } from "../../../types";
import styles from "./contact-card.module.less";
import { useTranslation } from "react-i18next";

export type TContactCardProps = {
  title: string;
  name: string;
  phone?: string;
  email?: string;
  image?: TImage;
  imageLoading?: TImageLoading;
};

const ContactCard = ({ title, name, phone, email, image, imageLoading }: TContactCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      {image?.url && <img src={image.url} alt={image.alt || name} className={styles.image} loading={imageLoading} />}
      <div className={styles.contentWrapper}>
        <p className={[styles.text, "h5"].join(" ")}>{name}</p>
        <p className={[styles.heading, "body-s"].join(" ")}>{title}</p>
        {phone && (
          <>
            <p className={[styles.heading, "body-base bold"].join(" ")}>{t("PHONE")}</p>
            <p className={[styles.text, "body-s"].join(" ")}>{phone}</p>
          </>
        )}
        {email && (
          <>
            <p className={[styles.heading, "body-base bold"].join(" ")}>{t("EMAIL")}</p>
            <a href={`mailto:${email}`} className={[styles.text, "body-s"].join(" ")}>
              {email}
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactCard;
